import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action} from 'mobx';
import {injectIntl} from 'react-intl';
import './styles.scss';
import BaseConfirmationDialog from "../../components/dialog/BaseConfirmationDialog";

@injectIntl
@inject('videoChatStore')
@observer
class GenericVideoDialog extends Component {

    closeDialog = () => {
        const {dialogId, onClose} = this.props;
        onClose(dialogId);

    }

    @action handleAcceptClick = () => {
        const {handleAccept} = this.props;
        this.closeDialog();
        handleAccept && handleAccept();
    }

    handleCancelClick = () => {
        const {handleCancel} = this.props;
        this.closeDialog();
        handleCancel && handleCancel();
    }

    handleCloseClick = () => {
        const {handleClose} = this.props;
        this.closeDialog();
        handleClose && handleClose();
    }


    render() {
        const {dialogId, titleKey, textKey, itemName, buttonKey, cancelButtonText, isOpen} = this.props;
        const confirmation = {
            question: titleKey,
            message: textKey,
            itemName: itemName
        };

        return (
            <BaseConfirmationDialog
                withClose={true}
                classes={{root: 'modal-root', paper: 'paper'}}
                onDismiss={this.handleCancelClick}
                onSubmit={this.handleAcceptClick}
                onOutsideClick={this.handleCloseClick}
                open={isOpen(dialogId)}
                isCancel={!!cancelButtonText}
                preventClickOutside={true}
                buttonText={buttonKey}
                cancelButtonText={cancelButtonText}
                text={confirmation}
            />
        );
    }
}

export default GenericVideoDialog;
